import {carModificationTypes, YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableCustomDateTimePickerBlock
    from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";

export default function CarPurchaseInfo({data, handlers, setCurrentStep}) {

    return (
        <div className="car-purchase-info">

            <div className="row">

                {/* Did you purchase the car? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3"
                    labelText="Did you purchase the car?"
                    required={true}
                    controlName="carPurchased"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.carPurchased}
                    onChange={handlers.onControlChange}
                />

            </div>

            {/* carPurchased */}

            {data.carPurchased === 'Yes' && (

                <div className="row">


                    {/* When did you purchase the car? */}

                    <ScrollableCustomDateTimePickerBlock
                        containerCssClass="col-12 py-3"
                        labelText="When did you purchase the car?"
                        required={data.carPurchased === 'Yes'}
                        controlName="carPurchaseDate"
                        value={data.carPurchaseDate}
                        onChange={handlers.onControlChange}
                    />
                </div>

            )}


        </div>
    );

}